import { Link } from 'react-router-dom'
import { Shield, ArrowRight, CheckCircle2 } from 'lucide-react'
import { useAuth } from '../context/AuthProvider'

export default function Landing() {
  const { user } = useAuth()

  return (
    <div className="max-w-4xl mx-auto py-16 px-4 space-y-16">
      {/* Hero */}
      <div className="text-center space-y-6">
        <div className="w-16 h-16 rounded-2xl bg-brand-100 dark:bg-brand-900/40 flex items-center justify-center mx-auto">
          <Shield size={32} className="text-brand-600 dark:text-brand-400" />
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-gray-100 tracking-tight">
          Representation,<br />done right.
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto leading-relaxed">
          Create a trusted AI persona that represents you or your business — with your explicit consent, within boundaries you define, and under your complete control.
        </p>
        {/* Single-CTA hero — the navbar's Sign In (sticky, top-right) covers the
            returning-user entry point, so the hero stays focused on the
            conversion path. Linear / Vercel / Stripe / Notion all follow this
            pattern; a secondary Sign In next to the primary button splits
            attention without adding anything the nav doesn't already provide. */}
        <div className="flex justify-center">
          {user ? (
            <Link to="/dashboard" className="btn-primary text-base px-6 py-3">
              Go to Dashboard <ArrowRight size={18} />
            </Link>
          ) : (
            <Link to="/signin" className="btn-primary text-base px-6 py-3">Create Your Persona</Link>
          )}
        </div>
      </div>

      {/* Trust signals */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          { title: 'Consent-First', desc: 'Your persona only becomes active after you explicitly consent. You control what it can and cannot represent.' },
          { title: 'Defined Scope', desc: 'Set clear boundaries. Your persona only responds within the topics you authorize — nothing more.' },
          { title: 'Instant Control', desc: 'Pause, edit, or delete your persona at any time. Changes take effect immediately.' },
        ].map((item) => (
          <div key={item.title} className="card p-6 space-y-3">
            <CheckCircle2 size={20} className="text-brand-600 dark:text-brand-400" />
            <h3 className="font-semibold text-gray-900 dark:text-gray-100">{item.title}</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="text-center text-xs text-gray-400 dark:text-gray-500 pt-8 border-t border-gray-200 dark:border-gray-800">
        <p>IDFY authorizes representation, not people.</p>
        <p className="mt-1">Powered by IDFY · idfy.studio</p>
      </div>
    </div>
  )
}
